import { CropEditor } from "@/Partials/AdEditor/Components/CropEditor";
import { ActionIcon, Box, Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconCrop } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

export const CropImageActionIcon = ({ src = '', ...props }) => {

    const { t } = useTranslation();

    const [opened, { open, close }] = useDisclosure(false);

    return (
        <>
            <Modal size="xl" opened={opened} onClose={close} title={t('logo.crop')} centered withinPortal>
                <div>
                    <Box pos="relative">
                        <CropEditor src={src} onCrop={(crop) => props?.onCrop(crop?.toDataURL())} />
                    </Box>
                </div>
            </Modal>
            <ActionIcon size="md" variant="transparent" color="white" onClick={open} {...props}>
                <IconCrop />
            </ActionIcon>
        </>
    )
}